import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dc385998")

_pushScopeId("data-v-dc385998")
const _hoisted_1 = { class: "overlays-list" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { style: {"flex":"1"} }, " Overlay Management ", -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "content-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "event" }, [
    /*#__PURE__*/_createVNode("span", null, "Event")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "overlay-name" }, [
    /*#__PURE__*/_createVNode("span", null, "Name")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_OverlayCard = _resolveComponent("OverlayCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isEditor)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            class: "esri-icon-plus icon",
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.onNewOverlay && _ctx.onNewOverlay(...args))),
            title: "To add a new overlay, first click on the map to draw an area where to locate the area. Double click to terminate the drawing of the area, then complete the creation of a new overlay"
          }))
        : _createCommentVNode("", true),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.overlaysList, (overlay) => {
        return (_openBlock(), _createBlock(_component_OverlayCard, { overlay: overlay }, null, 8, ["overlay"]))
      }), 256))
    ])
  ]))
})